import { FC, FormHTMLAttributes } from 'react';
import { twJoin } from 'tailwind-merge';

type VerticalFormProps = FormHTMLAttributes<HTMLFormElement> & {
  id: string;
};

export const VerticalForm: FC<VerticalFormProps> = ({
  id,
  children,
  className,
  ...rest
}) => {
  return (
    <form
      id={id}
      className={twJoin('flex flex-col gap-5', className)}
      {...rest}
    >
      {children}
    </form>
  );
};
